<template>
  <div class="main-background filter-page-container">
    <button type="button"
      class="filter-page-back-button"
      @click="$emit('setIsChangePage', 'cart')"
    >
      <chevron-left-icon class="back-button-icon" />
      <p class="back-button-text">Назад у кошик</p>
    </button>
    <div
      id="makeOrderContent"
      class="make-order-page-inputs-container"
      :style="{ height: formHeight + 'px' }"
    >
      <p class="make-order-page-main-title">Оформлення замовлення</p>
      <p class="make-order-page-under-main-title">
        Введіть ваші контактні дані
      </p>
      <div class="make-order-input-container">
        <label class="make-order-input-label" for="first-name">Ім'я</label>
        <input
          v-model="customerName"
          class="make-order-input"
          @keyup.enter="handleEnterKey"
          minlength="3"
          maxlength="30"
          type="text"
          :aria-invalid="Boolean(fieldErrors.delivery_first_name)"
          id="first-name"
          placeholder="Іван"
          @focus="isOpenKeyboard(true)"
          @blur="isOpenKeyboard(false)"
        />
        <p
          v-if="isRequiredError && customerName.length < 3"
          class="error-message-text"
        >
          Обов'язкове поле
        </p>
        <p v-if="isShowCyrillicName" class="error-message-text">
          Поле може бути заповнене лише кирилицею
        </p>
      </div>
      <div class="make-order-input-container">
        <label class="make-order-input-label" for="last-name">Прізвище</label>
        <input
          v-model="customerSecondName"
          class="make-order-input"
          @keyup.enter="handleEnterKey"
          @focus="isOpenKeyboard(true)"
          @blur="isOpenKeyboard(false)"
          minlength="3"
          maxlength="30"
          type="text"
          :aria-invalid="Boolean(fieldErrors.delivery_last_name)"
          id="last-name"
          placeholder="Іванов"
        />
        <p
          v-if="isRequiredError && customerSecondName.length < 3"
          class="error-message-text"
        >
          Обов'язкове поле
        </p>
        <p v-if="isShowCyrillicSecondName" class="error-message-text">
          Поле може бути заповнене лише кирилицею
        </p>
      </div>
      <div class="make-order-input-container">
        <label class="make-order-input-label" for="customer-phone">Номер телефону</label>
        <input
          v-model="onOrderPhoneNumber"
          @keyup.enter="handleEnterKey"
          inputmode="tel"
          @input="validatePhoneNumber"
          class="make-order-input"
          @focus="isOpenKeyboard(true)"
          type="text"
          :aria-invalid="!isValidPhoneNumber || Boolean(fieldErrors.delivery_phone)"
          @blur="normalizePhoneInput"
          id="customer-phone"
          placeholder="+380 63 633 63 63"
        />
        <p v-if="!isValidPhoneNumber" class="error-message-text">Введіть український номер: 067 123 45 67 або +380 67 123 45 67.</p>
      </div>
      <p class="make-order-page-title">Адреса доставки</p>
      <div class="make-order-input-container">
        <label class="make-order-input-label" for="textCity">Місто</label>
        <input
          v-model="customerCity"
          @keyup.enter="handleEnterKey"
          @input="debouncedSearch"
          :class="`make-order-input ${branchCity ? 'selected' : ''}`"
          @focus="setIsShowCitys"
          @blur="isOpenKeyboard(false)"
          type="text"
          id="textCity"
          placeholder="Введіть місто"
        />
        <p v-if="isRequiredError && !branchCity" class="error-message-text">
          Обов'язкове поле
        </p>
        <request-state :loading="cityLoading" :error="cityError" loading-text="Шукаємо місто…" @retry="searchCities" />
        <p v-if="citySearched && isShowCitys && !cityLoading && !cityError && !searchedTowns.length" role="status">Місто не знайдено. Змініть запит.</p>
        <div
          v-if="searchedTowns.length && isShowCitys"
          class="searched-order-towns"
        >
          <vue-perfect-scrollbar class="perfect-town-scrollbar">
            <button type="button"
              v-for="town of searchedTowns"
              :key="town.uuid_city"
              @click="onClickToCity(town)"
              :class="`searched-order-town-item ${branchCity && branchCity.uuid_city === town.uuid_city ? 'selected' : ''}`"
            >
              {{ town.name }}
            </button>
          </vue-perfect-scrollbar>
        </div>
      </div>
      <div class="make-order-input-container">
        <label class="make-order-input-label" for="branch-input">Відділення Нової Пошти</label>
        <input
          v-model="customerPostNumber"
          @keyup.enter="handleEnterKey"
          @focus="setIsShowBranch"
          autocomplete="off"
          :class="`make-order-input ${usedBranch ? 'selected' : ''}`"
          @blur="isOpenKeyboard(false)"
          type="text"
          id="branch-input"
          placeholder="Відділення №"
        />
        <p v-if="isRequiredError && !usedBranch" class="error-message-text">
          Обов'язкове поле
        </p>
        <request-state v-if="!isShowranch" :loading="branchLoading" :error="branchError" loading-text="Завантажуємо відділення…" @retry="onSearchCitysBranch" />
        <div v-if="isShowranch" class="searched-order-posts show" @keydown.esc="isShowranch = false">
          <button type="button" class="branch-close" aria-label="Закрити список відділень" @click="isShowranch = false">Закрити</button>
          <input
            id="branch-search"
            @keyup.enter="handleEnterKey"
            type="text"
            placeholder="Пошук"
            aria-label="Пошук серед відділень"
            v-model="filterPostText"
            @focus="isOpenKeyboard(true)"
            @blur="isOpenKeyboard(false)"
            class="searched-input-post"
          />
          <request-state :loading="branchLoading" :error="branchError" loading-text="Завантажуємо відділення…" @retry="onSearchCitysBranch" />
          <p v-if="!branchLoading && !branchError && !filteredPostNumbers.length" role="status">Відділень не знайдено. Змініть пошук або виберіть інше місто.</p>
          <vue-perfect-scrollbar class="perfect-town-scrollbar">
            <button type="button"
              v-for="branch of filteredPostNumbers"
              :key="branch.id"
              @click="onCLickToBranch(branch)"
              :class="`searched-order-town-item ${usedBranch && usedBranch.id === branch.id ? 'selected' : ''}`"
            >
              {{ branch.text }}
            </button>
          </vue-perfect-scrollbar>
        </div>
      </div>
    </div>
    <div class="bottom-filter-button-container">
      <div class="final-price-container">
        <p class="final-price">Усього</p>
        <p class="final-price">{{ cartElements.sumTotal | money }}</p>
      </div>
      <div class="error-message-container" v-if="isShowError" role="alert">
        <p class="error-message-text">
          {{ formError || 'Не вдалося зберегти дані доставки. Перевірте дані та спробуйте ще раз.' }}
        </p>
      </div>
      <button
        v-if="!isLoadingFetch && !isHideMainButton"
        class="filtration-button"
        :disabled="cityLoading || branchLoading"
        @click="setMakeOrder"
      >
        Оформити замовлення
      </button>
      <button
        v-else-if="isLoadingFetch && !isHideMainButton"
        class="filtration-button"
        disabled
        aria-label="Зберігаємо дані доставки"
      >
        <loader-spinner class="button-loading-spinner" :LoaderColor="true" />
      </button>
    </div>
  </div>
</template>

<script>
import { normalizePhone } from '../helpers/phone';
import { ChevronLeftIcon } from "vue-feather-icons";
import debounce from "lodash/debounce";
import { GET_CITYS, GET_ORDER_BRANCH } from "../helpers/requests";
import LoaderSpinner from "../../../components/LoaderSpinner.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import RequestState from "../../../components/RequestState.vue";

export default {
  name: "make-order-page",
  components: {
    ChevronLeftIcon,
    LoaderSpinner,
    VuePerfectScrollbar,
    RequestState,
  },
  props: {
    addedToCardProducts: {
      type: Array,
      required: true,
    },
    telegram: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      cityLoading: false,
      cityDebounce: null,
      cityError: "",
      citySearched: false,
      cityRequestId: 0,
      branchLoading: false,
      branchError: "",
      branchRequestId: 0,
      formError: "",
      fieldErrors: {},
      productCounter: 0,
      customerName: "",
      customerSecondName: "",
      customerPostNumber: "",
      onOrderPhoneNumber: "+380",
      customerCity: "",
      filterPostText: "",
      isWrongFormat: false,
      isLoading: true,
      branchCity: null,
      usedBranch: null,
      isShowranch: false,
      searchedTowns: [],
      searchedBranch: [],
      filteredPostNumbers: [],
      resultMakePrder: null,
      isShowError: false,
      isLoadingFetch: false,
      isValidPhoneNumber: true,
      isRequiredError: false,
      formHeight: 0,
      isShowCitys: false,
      isShowCyrillicName: false,
      isShowCyrillicSecondName: false,
      isHideMainButton: false,
    };
  },
  created() {
    this.cityDebounce = debounce(this.searchCities, 300);
  },
  mounted() {
    console.log('Make order page opened');
    this.formHeight = window.innerHeight - 220 - 118;
    window.scrollTo(0, 0);
    const customer = this.getOrderId?.customer || {};
    this.customerName = customer.first_name || "";
    this.customerSecondName = customer.last_name || "";
    this.onOrderPhoneNumber = customer.phone || "+380";
    this.telegram.MainButton.onClick(this.onTelegramMainButton);
  },
  beforeDestroy() {
    this.cityDebounce?.cancel();
    this.cityRequestId += 1;
    this.branchRequestId += 1;
    this.telegram.MainButton.offClick?.(this.onTelegramMainButton);
  },
  computed: {
    getOrderId() {
      return this.$store.getters.getOrderId;
    },
    cartElements() {
      return this.$store.getters.getCustomerCart;
    },
  },
  methods: {
    debouncedSearch() { this.cityDebounce(); },
    onTelegramMainButton() { this.handleEnterKey(); },
    async searchCities() {
      const q = this.customerCity.trim();
      if (q.length < 2 || !this.getOrderId?.id) return;
      const requestId = ++this.cityRequestId;
      this.cityLoading = true;
      this.cityError = "";
      this.citySearched = false;
      this.searchedTowns = [];
      try {
        const result = await GET_CITYS({ order_id: this.getOrderId.id, q });
        if (!Array.isArray(result.data)) throw new Error("Invalid cities response");
        if (requestId === this.cityRequestId) { this.searchedTowns = result.data; this.citySearched = true; }
      } catch (error) {
        if (requestId === this.cityRequestId) this.cityError = "Не вдалося знайти місто. Спробуйте ще раз.";
      } finally {
        if (requestId === this.cityRequestId) this.cityLoading = false;
      }
    },
    handleEnterKey() {
      const activeElement = document.activeElement;
      if (activeElement.tagName === "INPUT") {
        activeElement.blur();
        if (this.searchedTowns.length) {
          this.searchedTowns = [];
        }
      }
    },
    isOpenKeyboard(value) {
      if (this.telegram.platform === "tdesktop") {
        return;
      }
      if (value) {
        this.telegram.MainButton.setParams({
          text: "Готово",
          color: "#01bace",
          text_color: "#fff",
        });
        this.telegram.MainButton.show();
        this.isHideMainButton = true;
      } else {
        this.telegram.MainButton.hide();
        this.isHideMainButton = false;
      }
    },
    validatePhoneNumber() {
      this.isValidPhoneNumber = Boolean(normalizePhone(this.onOrderPhoneNumber));
      if (this.isValidPhoneNumber && this.fieldErrors.delivery_phone) {
        this.$delete(this.fieldErrors, 'delivery_phone');
        this.isShowError = false;
      }
    },
    normalizePhoneInput() {
      const phone = normalizePhone(this.onOrderPhoneNumber);
      if (phone) this.onOrderPhoneNumber = '+' + phone;
      this.validatePhoneNumber();
      this.isOpenKeyboard(false);
    },
    focusField(key) {
      const ids = { delivery_first_name: 'first-name', delivery_last_name: 'last-name', delivery_phone: 'customer-phone', city: 'textCity', uuid: 'branch-input' };
      this.$nextTick(() => { const input = document.getElementById(ids[key]); input?.scrollIntoView({ block: 'center', behavior: 'smooth' }); input?.focus(); });
    },
    setIsShowCitys() {
      this.isOpenKeyboard(true);
      this.isShowCitys = true;
    },
    setIsShowBranch() {
      this.isOpenKeyboard(true);
      if (!this.branchCity) return;
      this.isShowranch = true;
      this.$nextTick(() => document.getElementById("branch-search")?.focus());
    },
    setHawePlusOnNumber(number) {
      if (number.startsWith("+")) {
        return number.slice(1);
      } else {
        return number;
      }
    },
    async setMakeOrder() {
      if (this.isLoadingFetch || this.cityLoading || this.branchLoading) return;
      this.fieldErrors = {};
      const phone = normalizePhone(this.onOrderPhoneNumber);
      if (this.customerName.trim().length < 3 || this.isShowCyrillicName) this.fieldErrors.delivery_first_name = 'Вкажіть ім’я кирилицею, щонайменше 3 символи.';
      if (this.customerSecondName.trim().length < 3 || this.isShowCyrillicSecondName) this.fieldErrors.delivery_last_name = 'Вкажіть прізвище кирилицею, щонайменше 3 символи.';
      if (!phone) this.fieldErrors.delivery_phone = 'Введіть український номер: 067 123 45 67 або +380 67 123 45 67.';
      if (!this.branchCity) this.fieldErrors.city = 'Виберіть місто зі списку.';
      if (!this.usedBranch) this.fieldErrors.uuid = 'Виберіть відділення зі списку.';
      this.isValidPhoneNumber = Boolean(phone);
      this.isRequiredError = Boolean(Object.keys(this.fieldErrors).length);
      if (this.isRequiredError) {
        const first = Object.keys(this.fieldErrors)[0];
        this.formError = this.fieldErrors[first]; this.isShowError = true; this.focusField(first); return;
      }
      this.isLoadingFetch = true;
      this.isShowError = false;
      this.formError = "";
      let data = {
        order_id: this.getOrderId.id,
        uuid: this.usedBranch.id,
        delivery_phone: phone,
        delivery_first_name: this.customerName.trim(),
        delivery_last_name: this.customerSecondName.trim(),
      };
      try {
        const result = await this.$store.dispatch("setSaveOrder", JSON.stringify(data));
        if (result.status !== true) throw new Error("Delivery not saved");
        this.$emit("setIsChangePage", "success");
      } catch (error) {
        this.isShowError = true;
        const errors = error.status === 422 ? (error.details.errors || error.details) : {};
        const keys = ['delivery_first_name', 'delivery_last_name', 'delivery_phone', 'uuid'];
        const first = keys.find(key => errors[key]);
        this.fieldErrors = errors;
        this.formError = first ? (Array.isArray(errors[first]) ? errors[first][0] : errors[first]) : 'Не вдалося зберегти дані доставки. Перевірте з’єднання та спробуйте ще раз.';
        if (first) this.focusField(first);
      } finally { this.isLoadingFetch = false; }
    },
    onClickToCity(value) {
      this.cityDebounce?.cancel();
      this.cityRequestId += 1;
      this.cityLoading = false;
      this.cityError = "";
      if (!value.uuid_city) {
        this.searchedTowns = [];
        this.isShowCitys = false;
        return;
      }
      this.branchCity = value;
      this.customerCity = value.name;
      this.searchedTowns = [];
      this.isShowCitys = false;
      this.onSearchCitysBranch();
      
    },
    onCLickToBranch(value) {
      this.usedBranch = value;
      this.customerPostNumber = value.text;
      this.isShowranch = false;
    },
    async onSearchCitysBranch() {
      if (!this.branchCity || !this.getOrderId?.id) return;
      const requestId = ++this.branchRequestId;
      const city = this.branchCity.uuid_city;
      this.branchLoading = true;
      this.branchError = "";
      this.searchedBranch = [];
      try {
        const result = await GET_ORDER_BRANCH({ order_id: this.getOrderId.id, uuid_city: city });
        if (!Array.isArray(result.data)) throw new Error("Invalid branches response");
        if (requestId === this.branchRequestId && city === this.branchCity?.uuid_city) this.searchedBranch = result.data;
      } catch (error) {
        if (requestId === this.branchRequestId) this.branchError = "Не вдалося завантажити відділення. Спробуйте ще раз.";
      } finally {
        if (requestId === this.branchRequestId) this.branchLoading = false;
      }
    },
    setChangeCounter(value) {
      if (value === "+") {
        this.productCounter += 1;
      } else {
        this.productCounter -= 1;
      }
    },
  },
  watch: {
    customerCity(value) {
      this.cityRequestId += 1;
      this.cityLoading = false;
      this.cityError = "";
      this.citySearched = false;
      this.searchedTowns = [];
      if (this.branchCity && value !== this.branchCity.name) {
        this.branchCity = null;
        this.branchRequestId += 1;
        this.branchLoading = false;
        this.branchError = "";
        this.searchedBranch = [];
        this.isShowranch = false;
      }
    },
    customerName(newValue, oldVaue) {
      if (!newValue) {
        this.isShowCyrillicName = false;
        return;
      }
      let reg = /^[\u0400-\u04FF]+(?:['’ʼ-][\u0400-\u04FF]+)*$/;
      if (reg.test(newValue)) {
        this.isShowCyrillicName = false;
      } else {
        this.isShowCyrillicName = true;
      }
      let val = oldVaue;
      val;
    },
    customerSecondName(newValue, oldVaue) {
      if (!newValue) {
        this.isShowCyrillicSecondName = false;
        return;
      }
      let reg = /^[\u0400-\u04FF]+(?:['’ʼ-][\u0400-\u04FF]+)*$/;
      if (reg.test(newValue)) {
        this.isShowCyrillicSecondName = false;
      } else {
        this.isShowCyrillicSecondName = true;
      }
      let val = oldVaue;
      val;
    },
    customerPostNumber(newValue, oldVaue) {
      let val = oldVaue;
      val;
      this.filterPostText = newValue;
    },
    branchCity(newValue, oldVaue) {
      let val = oldVaue;
      val;
      this.usedBranch = null;
      this.customerPostNumber = "";
      this.searchedBranch = [];
    },
    searchedBranch(newValue, oldVaue) {
      let val = oldVaue;
      val;
      this.filteredPostNumbers = newValue;
    },
    filterPostText(newValue, oldValue) {
      let val = oldValue;
      val;
      if (newValue?.length >= 1) {
        let newArray = this.searchedBranch.filter((post) =>
          post.text.toLowerCase().includes(newValue.toLowerCase())
        );
        this.filteredPostNumbers = newArray;
      } else {
        this.filteredPostNumbers = this.searchedBranch;
      }
    },
    resultMakePrder(newValue, oldValue) {
      let val = oldValue;
      val;
      this.isLoadingFetch = false;
      if (newValue === true) {
        this.$emit("setIsChangePage", "success");
      } else {
        this.isShowError = true;
      }
    },
  },
};
</script>

<style scoped>
.main-background {
  background: #fff;
}
.filter-page-back-button {
  position: relative;
  border-bottom: 1px solid #f0f0f0;
  padding: 18px;
  cursor: pointer;
}

.back-button-icon {
  position: absolute;
}

.back-button-text {
  text-align: center;
}

.filter-page-container {
  display: flex;
  flex-direction: column;
}

.bottom-filter-button-container {
  background: #fff;
  box-shadow: 0px -4px 4px 0px rgba(0, 0, 0, 0.04);
  padding: 16px;
  z-index: 100;
}

.filtration-button {
  padding: 12px;
  width: 100%;
  border-radius: 8px;
  background: #16abb8;
  color: #fff;
  text-align: center;
  font-family: Inter;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  border: none;
  cursor: pointer;
  margin-bottom: 10px;
}

.return-to-shop {
  padding: 12px;
  width: 100%;
  border-radius: 8px;
  background: #fff;
  color: #16abb8;
  text-align: center;
  font-family: Inter;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  border: none;
  cursor: pointer;
  margin-bottom: 10px;
  border: 1px solid #16abb8;
}

.final-price-container {
  display: flex;
  justify-content: space-between;
}
.final-price {
  color: #121212;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  margin-bottom: 5px;
}
.make-order-page-inputs-container {
  padding: 0 16px 5px 16px;
  margin-top: 4px;
  margin-bottom: 10px;
  overflow-y: scroll;
}

.make-order-input-container {
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  position: relative;
}
.make-order-input-label {
  color: #707070;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}

.make-order-input {
  border-radius: 8px;
  border: 1px solid #d2d6db;
  background: #fff;
  color: #707070;
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  padding: 10px 15px;
  margin-top: 4px;
  outline-color: #01bace;
  transition: all 0.3s ease;
}

.make-order-input.selected {
  border-color: #01bace;
  background-color: #f8fdfd;
  color: #01bace;
  font-weight: 600;
}

.make-order-page-title {
  margin-top: 16px;
  color: #121212;
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
}

.make-order-page-main-title {
  color: #333;
  font-family: Inter;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
}

.make-order-page-under-main-title {
  color: #333;
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  margin-top: 8px;
}

.searched-order-posts {
  position: fixed;
  width: 100%;
  max-height: 350px;
  padding: 10px;
  left: 0px;
  bottom: 0px;
  z-index: 101;
  background: #fff;
  overflow: hidden;
  transform: translateY(100%);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  transition: all 0.5s ease;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
}

.searched-order-posts.show {
  transform: translateY(0);
}

.searched-order-towns {
  position: absolute;
  width: 100%;
  max-height: 150px;
  overflow: hidden;
  background-color: #ffffff;
  border: 1px solid #d2d6db;
  border-radius: 8px;
  padding: 10px 5px;
  bottom: 45px;
}

.searched-order-town-item {
  padding: 10px;
  cursor: pointer;
  color: #707070;
  border-radius: 5px;
  transition: all 0.2s ease;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
  -webkit-user-select: none;
}

.searched-order-town-item:hover {
  background-color: #01bace;
  color: #fff;
}

.searched-order-town-item:active {
  background-color: #01bace;
  color: #fff;
  transform: scale(0.98);
}

/* iOS specific touch feedback */
@supports (-webkit-touch-callout: none) {
  .searched-order-town-item:active {
    background-color: #01bace;
    color: #fff;
    transform: scale(0.95);
    transition: all 0.1s ease;
  }
}

/* Selected state for better visibility */
.searched-order-town-item.selected {
  background-color: #01bace;
  color: #fff;
  font-weight: 600;
  border: 2px solid #01bace;
}

.searched-order-town-item.selected:hover {
  background-color: #00a8b8;
  border-color: #00a8b8;
}

.branch-loading-container {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}

.branch-loading-text {
  color: #707070;
  font-family: "Lato", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 25px;
  margin-top: 20px;
}
.branch-loading-spinner {
  margin: auto 0;
}

.button-loading-spinner {
  margin: auto;
}
.perfect-town-scrollbar {
  height: 400px;
}

.searched-input-post {
  border-radius: 8px;
  border: 1px solid #d2d6db;
  background: #fff;
  color: #707070;
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  padding: 10px 15px;
  margin-top: 4px;
  outline-color: #01bace;
  width: 100%;
  margin-bottom: 10px;
}

.error-message-container {
  padding: 5px 10px;
}

.error-message-text {
  font-size: 12px;
  font-weight: 400;
  color: red;
}

/* === Значні покращення для великих екранів (1024px+) === */
@media (min-width: 1024px) {
  .main-background {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0;
  }

  .filter-page-back-button {
    max-width: 1400px;
    margin: 0 auto;
    padding: 24px 40px;
    border-bottom: 1px solid #f0f0f0;
  }

  .back-button-text {
    font-size: 20px;
    font-weight: 600;
  }

  .make-order-page-inputs-container {
    max-width: 900px;
    margin: 0 auto;
    padding: 40px;
  }

  .make-order-page-main-title {
    font-size: 32px;
    font-weight: 700;
    color: #1a1a1a;
    margin-bottom: 12px;
  }

  .make-order-page-under-main-title {
    font-size: 20px;
    margin-top: 16px;
    color: #4a4a4a;
  }

  .make-order-page-title {
    font-size: 24px;
    font-weight: 600;
    margin-top: 32px;
    color: #1a1a1a;
  }

  .make-order-input-container {
    margin-top: 24px;
  }

  .make-order-input-label {
    font-size: 16px;
    font-weight: 600;
    color: #4a4a4a;
    margin-bottom: 8px;
  }

  .make-order-input {
    font-size: 18px;
    padding: 16px 24px;
    margin-top: 8px;
    border-radius: 12px;
    transition: all 0.2s ease;
  }

  .make-order-input:focus {
    border-color: #01bace;
    box-shadow: 0 0 0 3px rgba(1, 186, 206, 0.1);
    background-color: #f8fdfd;
  }

  .make-order-input.selected {
    border-color: #01bace;
    background-color: #f8fdfd;
  }

  .searched-order-towns {
    max-height: 200px;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  }

  .searched-order-town-item {
    padding: 14px 16px;
    font-size: 16px;
  }

  .searched-order-posts {
    max-width: 700px;
    left: 50%;
    transform: translateX(-50%) translateY(100%);
    border-radius: 20px 20px 0 0;
  }

  .searched-order-posts.show {
    transform: translateX(-50%) translateY(0);
  }

  .searched-input-post {
    font-size: 16px;
    padding: 14px 20px;
    border-radius: 12px;
  }

  .bottom-filter-button-container {
    max-width: 900px;
    margin: 0 auto;
    padding: 30px 40px;
    border-radius: 20px 20px 0 0;
    box-shadow: 0 -8px 24px rgba(0, 0, 0, 0.1);
  }

  .final-price-container {
    margin-bottom: 24px;
  }

  .final-price {
    font-size: 24px;
    font-weight: 700;
  }

  .filtration-button {
    max-width: 600px;
    margin: 0 auto;
    font-size: 20px;
    font-weight: 700;
    padding: 18px;
    border-radius: 14px;
    transition: all 0.3s ease;
  }

  .filtration-button:hover {
    background: #14a0ad;
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(22, 171, 184, 0.4);
  }

  .error-message-text {
    font-size: 14px;
  }
}
</style>

<style scoped>
.searched-order-town-item { display: block; width: 100%; min-height: 44px; border: 0; background: #fff; text-align: left; cursor: pointer; }
.branch-close { display: block; min-height: 44px; padding: 8px 16px; margin-left: auto; background: #fff; border: 1px solid #075a63; border-radius: 6px; color: #075a63; cursor: pointer; }
.searched-order-posts { padding-bottom: env(safe-area-inset-bottom, 0px); }
</style>

<style scoped>
.filter-page-back-button { width: 100%; background: #fff; border: 0; border-bottom: 1px solid #f0f0f0; cursor: pointer; color: #333; }
</style>
